import { Injectable } from "@angular/core";
import { CMREventTypes } from "@shared/src/enums/CMREventTypes";

@Injectable()
export class SaveCMRAgentEventDto {
	public event: string;
	public cmrEventType: CMREventTypes;

	public static build(event: string, eventType: CMREventTypes): SaveCMRAgentEventDto{
		let data: SaveCMRAgentEventDto = new SaveCMRAgentEventDto();
		data.event = event;
		data.cmrEventType = eventType;
		return data;
	}
}